export default "__VITE_ASSET__CMQCO7xX__"